import React from 'react';
import CollectionProductTable from './CollectionProductTable';

const CollectionProducts = () => {
  return <CollectionProductTable />
}

export default CollectionProducts;